/**
 * Путь до фото на CDN
 */
export const photoCDN = (() => {
  if (process.env.NODE_ENV === 'test') {
    return 'test-photo-cdn'
  }
  return window.app && window.app.photoCDN
})()
